import { ButtonWithModal } from '../ButtonWithModal';

import * as styles from './Hint.module.css';

import type { ReactNode } from 'react';

export const Hint = ({ buttonText, children }: { buttonText: string; children: ReactNode }) => {
  return (
    <ButtonWithModal buttonText={buttonText} modalClassName={styles.hint}>
      {children}
    </ButtonWithModal>
  );
};
